export default __webpack_public_path__ + "static/media/1178.d37c7028.png";